import { useStore } from '../../context/StoreContext';

export function useTheme() {
  const { theme, setTheme } = useStore();
  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');
  return { theme, toggleTheme };
}
